import api from "./axiosAPI";

// Mirrors AlertViewSet.filterset_fields in the Django backend.
export const alertsFilterParams = ["is_resolved", "message", "team"];

export const alertsAPI = {
    fetchAlerts: (params = {}) => {
        return api.get('/alerts/', { params });
    },
    fetchAlertById: (id) => {
        return api.get(`/alerts/${id}`);
    },
    fetchAlertOptions: () => {
        return api.options('/alerts/');
    },
    fetchAlertFilters: () => {
        return api.get('/alerts/filters/');
    },
    comment(id, comment) {
        return api.post(`/alerts/${id}/add-comment/`, { comment });
    },
    patchUserResponse: (id, data) => {
        return api.patch(`/alerts/${id}/user-response/`, data);
    },
    assignToMe: (id) => {
        return api.post(`/alerts/${id}/assign-to-me/`);
    },
    markAsRead: (id) => {
        return api.post(`/alerts/${id}/mark-as-read/`);
    },
    resolve: (id) => {
        return api.post(`/alerts/${id}/resolve/`);
    },
    listComments: (alertId) => {
        return api.get('/alert-comments/', { params: { alert: alertId } });
    },
    createComment: (alertId, comment) => {
        return api.post('/alert-comments/', { alert: alertId, comment });
    },
    updateComment: (id, comment) => {
        return api.patch(`/alert-comments/${id}/`, { comment });
    },
    deleteComment: (id) => {
        return api.delete(`/alert-comments/${id}/`);
    },
};
